<template>
    <div class="video-link-container">
        <button @click.stop="generate_teams_meeting()" :disabled="ui.loading">
            {{ ui.loading ? 'Creating…' : 'Generate Teams Meeting' }}
        </button>
        <div>or paste a Teams / Zoom / Google Meet link</div>
        <div class="input-container">
            <input v-model="data.link" placeholder="paste a meeting link here">
            <button @click.stop="save_link_to_instructor(data.link)">Save</button>
        </div>
        <div v-if="ui.error" class="error">{{ ui.error }}</div>
        <div>or</div>
        <div class="videolink-history">
            <template v-if="data.videolinks">
                <div class="links-container">
                    <div>Previously used group links</div>
                    <div @click.stop="select_link(group_link)" class="link" :class="{selected:group_link==data.link}" v-for="group_link in data.videolinks.group_links">
                        {{ group_link }}
                    </div>
                </div>
                <div class="links-container">
                    <div>Links saved by instructor</div>
                    <div @click.stop="select_link(instructor_link)" class="link" :class="{selected:instructor_link==data.link}" v-for="instructor_link in data.videolinks.instructor_links">
                        {{ instructor_link }}
                        <div class="close" @click.stop="delete_videolink(instructor_link)">x</div>
                    </div>
                </div>


            </template>
        </div>
    </div>



</template>




<script setup>
    import {reactive,inject} from 'vue'
    import axios from 'axios'



    let data=inject('video_link_data')

    // local UI state so we don't pollute the shared video_link_data
    let ui=reactive({loading:false, error:''})


    async function generate_teams_meeting() {
        ui.error=''
        ui.loading=true
        try {
            let title='InterAct Class'+((data.group && data.group.name) ? ' - '+data.group.name : '')
            let response=await axios.post('/teams/create_meeting/',{title})
            data.link=response.data.join_url
        } catch (e) {
            ui.error=e.response?.data?.error || 'Failed to create Teams meeting.'
        } finally {
            ui.loading=false
        }
    }

    function select_link(link){
        data.link=link
    }

    async function save_link_to_instructor(link){
        if (!link){ return }
        let response= await axios.post('/instructors/save_link_to_instructor/',{link:link,user_id:data.user.id})
        let saved_videolink=response.data
        data.videolinks.instructor_links.push(saved_videolink.link)
    }

    async function delete_videolink(videolink){
        let videolink_id=data.videolinks.instructor_links.indexOf(videolink)
        data.videolinks.instructor_links.splice(videolink_id,1)
        let response=await axios.post('instructors/delete_videolink/',{videolink:videolink})

    }


</script>



<style scoped>

    .video-link-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        width: min-content;
        height: auto;
    }


    .videolink-history{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: start;
        width: 100%;
        max-width: 100%;
        gap:5px;
    }


    .links-container{
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        min-width: max-content;
        border: var(--border);
        border-color: var(--white);
        border-radius: 5px;
        padding: 5px;


    }

    .link{
        border: var(--border);
        border-radius: 5px;
        padding: 5px;
        background: var(--lightgray);
        color:var(--black);
        min-width: max-content;
        display: flex;



    }

    .selected{
        background: var(--darkgreen);
    }

    .close{
        background: var(--red);
        color: var(--white);
        font-size: large;
        border-radius: 2px;
        border: var(--border);
    }

    .error{
        color: var(--red);
        font-size: 0.85rem;
    }



</style>
